<template>
  <v-dialog v-model="dialog" width="560" @click:outside="cancel" :persistent="isLoading">
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('tanaoroshiInventoryDateDialog.label.title') }}</strong></h3>
      </v-card-title>
      <v-card-text>
        <div class="ml-4 mb-2" v-if="message" style="color: #2e7d32">
          {{ message }}
        </div>
        <div class="ml-4" v-if="errorMessage" style="color: red">
          {{ errorMessage }}
        </div>
        <div class="ml-4" v-for="data in errorList" :key="data.message" style="color: red">
          {{ data.message }}
        </div>

        <v-container>
          <v-row>
            <v-col cols="12">
              <!-- 店舗が多い（約700）ので、店舗コード・店舗名を打って候補を絞り込めるようにする（2026-10-23）。
                   auto-select-first は付けない。付けると打ち込んだときに先頭の店舗が強調され、選ばれたように見える（2026-11-01 打合せ・S-41。棚卸画面に合わせる） -->
              <v-autocomplete
                v-model="shopCode"
                :items="shopOptions"
                item-title="code_name"
                item-value="code"
                density="compact"
                variant="outlined"
                hide-details="auto"
                :label="$t('tanaoroshiInventoryDateDialog.label.shop')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <!-- 日付はお客様の環境（ブラウザの言語）によらず日本の形（yyyy-MM-dd・日曜始まりのカレンダー）で出す。ディセントの画面と同じ DatePicker（2026-11-02 依頼）。
                   ダイアログの中なのでカレンダーは body に出す（枠で切れないように。それまではこのためにブラウザ標準の日付入力にしていた） -->
              <DatePicker
                v-model="inventoryDate"
                variant="outlined"
                teleport="body"
                :label="$t('tanaoroshiInventoryDateDialog.label.date')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading">{{ $t('tanaoroshiInventoryDateDialog.action.close') }}</v-btn>
        <v-btn
          color="indigo darken-1"
          dark
          :loading="isLoading"
          :disabled="!isFormValid()"
          @click="register"
        >{{ $t('tanaoroshiInventoryDateDialog.action.register') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/apis/staff";
import constant from "@/utils/constant";
import utils from "@/utils";
import DatePicker from "@/components/DatePicker";

export default {
  components: { DatePicker },
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleCancel: {
      type: Function,
      required: true,
    },
  },

  computed: {
    shopOptions() {
      return this.dialogData.shopItem;
    },
  },

  data() {
    return {
      dialog: true,
      isLoading: false,
      message: "",
      errorMessage: "",
      errorList: [],
      // 一覧画面で選んでいる店舗を初期値にする
      shopCode: this.dialogData.shopCode ?? null,
      inventoryDate: "",
    };
  },

  methods: {
    isFormValid() {
      return !!(this.shopCode && this.inventoryDate);
    },
    clearMessages() {
      this.message = "";
      this.errorMessage = "";
      this.errorList = [];
    },
    cancel() {
      if (this.isLoading) return;
      this.handleCancel();
    },
    register() {
      this.isLoading = true;
      this.clearMessages();
      api
        .post("/tanaoroshi/inventory-date", {
          shopCode: this.shopCode,
          inventoryDate: this.inventoryDate,
        })
        .then((response) => {
          if (response.data.status == constant.RESPONSE_STATUS.SUCCESS) {
            // 続けて別の日を登録できるよう、店舗は残して日付だけ空にする
            this.message = this.$t("tanaoroshiInventoryDateDialog.message.registered", {
              date: this.inventoryDate,
              id: response.data.results?.tanaoroshiId,
            });
            this.inventoryDate = "";
            return;
          }
          this.errorMessage = response.data.errorMessage;
          this.errorList = response.data.errorList ?? [];
        })
        .catch((error) => {
          this.errorMessage = utils.getErrorMsg(error.response, this.$t);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
